class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    
    // Add hover events
    const summary = this.mainDetailsToggle.querySelector('summary');
    const parent = this.parentElement;
    
    if (parent && parent.classList.contains('mega-menu__item')) {
      parent.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      parent.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
    
    // Handle click on summary link
    summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  onMouseLeave() {
    // Don't close if mouse is over the content
    setTimeout(() => {
      const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
      if (!content.matches(':hover') && !this.mainDetailsToggle.matches(':hover')) {
        this.close();
      }
    }, 100);
  }

  onSummaryClick(event) {
    // Check if click is on the link inside summary
    const link = event.target.closest('a');
    if (link && link.classList.contains('header__menu-link')) {
      // Let the link handle navigation
      return;
    }
    
    // Prevent default toggle behavior
    event.preventDefault();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Override the parent behavior for mega menu items
    const parent = this.parentElement;
    if (parent && parent.classList.contains('mega-menu__item')) {
      // Remove default toggle behavior
      this.mainDetailsToggle.removeEventListener('toggle', this.onToggle);
    }
  }

  onToggle() {
    if (!this.header) return;
    
    // Only handle header position, not menu open/close
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Additional CSS to handle hover
document.addEventListener('DOMContentLoaded', function() {
  const megaMenuItems = document.querySelectorAll('.mega-menu__item');
  
  megaMenuItems.forEach(item => {
    const details = item.querySelector('details');
    const content = item.querySelector('.mega-menu__content');
    
    if (details && content) {
      // Close menu when mouse leaves the entire item (including content)
      item.addEventListener('mouseleave', function(e) {
        // Check if we're not moving to the content
        const relatedTarget = e.relatedTarget;
        if (!this.contains(relatedTarget)) {
          setTimeout(() => {
            if (!content.matches(':hover') && !details.matches(':hover')) {
              details.removeAttribute('open');
            }
          }, 100);
        }
      });
      
      // Prevent clicks on summary from toggling
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function(e) {
          const link = e.target.closest('a');
          if (link && link.classList.contains('header__menu-link')) {
            // Allow link to work
            return;
          }
          e.preventDefault();
        });
      }
    }
  });
});